import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import CallForwardingSetupModal from './CallForwardingSetupModal';
import VerifingStatusModal from './VerifingStatusModal';
import CarrierInstructionsModal from './CarrierInstructionsModal';
import { Loader } from './../UIComponents';
import Footnote from './../Footnote';

import utils from './../../lib/utils';

import './index.scss';

export default class PhoneSetup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      callForwardingModalVisibility: false,
      statusModalVisibility: false,
      carrierInstructionsModalVisibility: false,
    };

    this.onPreviousClick = this.onPreviousClick.bind(this);
//    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.onVerifyCancel = this.onVerifyCancel.bind(this);
    this.onVerifyStatusModalClose = this.onVerifyStatusModalClose.bind(this);
    this.onShowCarrierInstructionsClick = this.onShowCarrierInstructionsClick.bind(
      this,
    );
    this.onCarrierInstructionsModalClose = this.onCarrierInstructionsModalClose.bind(
      this,
    );
  }

  componentWillMount() {
    if (Object.keys(this.props.business.phoneList).length) {
      this.setState({
        callForwardingModalVisibility: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      typeof nextProps.business.isPhoneAdded === 'boolean' &&
      this.props.business.isPhoneAdded !== nextProps.business.isPhoneAdded
    ) {
      this.setState(
        {
          statusModalVisibility: true,
          callForwardingModalVisibility: false,
        },
        () => {
          // Hide status message after 3 sec
          setTimeout(() => {
            this.setState(
              {
                statusModalVisibility: false,
                callForwardingModalVisibility: false,
              },
              () => {
                // Redirect to summary screen
                this.props.history.push('/app/setup');
              },
            );
          }, 3000);
        },
      );
    }
  }

  onPreviousClick() {
    // Redirect to summary screen
    this.props.history.push('/app/setup');
  }

  /*onNextButtonClick() {
    this.setState({
      callForwardingModalVisibility: true,
      statusModalVisibility: false,
    });
  }*/

  onVerifyCancel() {
    this.setState({
      callForwardingModalVisibility: false,
    });
  }

  onVerifyStatusModalClose() {
    this.setState({
      statusModalVisibility: false,
      callForwardingModalVisibility: false,
    });
  }

  onShowCarrierInstructionsClick(event) {
    event.preventDefault();

    this.setState({
      carrierInstructionsModalVisibility: true,
    });
  }

  onCarrierInstructionsModalClose() {
    this.setState({
      carrierInstructionsModalVisibility: false,
    });
  }

  render() {
    const loaderWidth = 30;

    return (
      <div className="business-phone-summary">
        <p className="business-phone-summary__text">
          Forward missed calls to your TrueLark text-only number
        </p>
        <div className="connect-business-phone">
          <div className="connect-business-phone__card">
            <div className="card">
              <div className="card__header">
                <span className="card__header__text">
                  Conditional call forwarding
                </span>
                <NavLink className="btn btn--link" to="/app/help">
                  Need help?
                </NavLink>
              </div>
              <Loader width={`${loaderWidth}%`} />
              <div className="card__content">
                <div className="connect-business-phone__card__content">
                  <div className="link-phone">
                    {/* <p className="link-phone__error">
                      <i className="fas fa-exclamation-circle" aria-hidden="true"></i>
                      Sorry, we weren’t able to connect! Please try again or call Customer care!
                    </p> */}
                    <p className="link-phone__heading">
                      Let us handle your missed calls and voicemails!
                    </p>
                    <p className="link-phone__text">
                      Your TrueLark text-only number is:
                    </p>
                    <span className="mindbody-success__phone-no">
                      {utils.hyphenatePhone(this.props.carriers.phoneNumber)}
                      <p className="link-phone__text">
                        You must now setup your business phones to forward any
                        call that you miss to the above text-only number
                      </p>
                    </span>
                    <p className="link-phone__text">
                      Make sure the following are setup on all your business
                      phone numbers:
                    </p>
                    <div className="link-phone__steps">
                      <div className="steps">
                        <span className="steps__index">1:</span>
                        <span className="steps__text">
                          Call forwarding when unanswered
                        </span>
                      </div>
                      <div className="steps">
                        <span className="steps__index">2:</span>
                        <span className="steps__text">
                          Call forwarding when busy
                        </span>
                      </div>
                    </div>
                    <p className="link-phone__text">
                      Please check with your service provider for instructions
                      on how to setup your call forwarding. A handy reference
                      for some common service providers can be found&nbsp;
                      <a
                        href=""
                        className="btn btn--link"
                        onClick={this.onShowCarrierInstructionsClick}
                      >
                        here
                      </a>
                    </p>
                    <div className="link-phone__actions">
                      <button
                        className="btn btn--secondary btn--lg"
                        onClick={this.onPreviousClick}
                      >
                        Previous
                      </button>
                      {/*<button
                        className="btn btn--primary btn--lg"
                        onClick={this.onNextButtonClick}
                      >
                        Verify
                      </button>*/}
                      <NavLink
                        className="btn btn--secondary btn--lg"
                        to="/app/setup"
                      >
                        Done
                      </NavLink>
                    </div>
                    {/*<CallForwardingSetupModal
                      {...this.props}
                      visibility={this.state.callForwardingModalVisibility}
                      onCancel={this.onVerifyCancel}
                    />*/}
                    <VerifingStatusModal
                      visibility={this.state.statusModalVisibility}
                      status={
                        this.props.business.isPhoneAdded ? 'success' : 'error'
                      }
                      onClose={this.onVerifyStatusModalClose}
                    />
                    <CarrierInstructionsModal
                      twilioNumber={this.props.carriers.phoneNumber}
                      visibility={this.state.carrierInstructionsModalVisibility}
                      onClose={this.onCarrierInstructionsModalClose}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footnote />
        </div>
      </div>
    );
  }
}

PhoneSetup.defaultProps = {
  router: {
    push: () => {},
  },
};

PhoneSetup.propTypes = {
  business: PropTypes.shape({
    isPhoneAdded: PropTypes.bool,
    phoneList: PropTypes.shape(),
  }).isRequired,
  carriers: PropTypes.shape({
    phoneNumber: PropTypes.string,
  }).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
};
